module.exports = __webpack_public_path__ + "static/media/industrial.ac95c0f9.jpeg";